"use client";

import { useEffect, useState } from "react";

// Measures the horizontal center (in viewport px) of the content column so
// the fixed-positioned SummarizeBar can be centered under it specifically —
// `position: fixed` is always viewport-relative, so a plain `left-1/2`
// centers under the whole page instead of the (narrower, right-offset)
// content column next to the TOC. Recomputed on resize and whenever the
// column's own box changes (e.g. the TOC column appearing/disappearing
// across breakpoints).
export function useColumnCenterX(columnId: string): number | null {
  const [centerX, setCenterX] = useState<number | null>(null);

  useEffect(() => {
    const el = document.getElementById(columnId);
    if (!el) return;

    const measure = () => {
      const rect = el.getBoundingClientRect();
      setCenterX(rect.left + rect.width / 2);
    };

    measure();
    window.addEventListener("resize", measure);
    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(el);

    return () => {
      window.removeEventListener("resize", measure);
      resizeObserver.disconnect();
    };
  }, [columnId]);

  return centerX;
}
